import { render } from "./GifsTableUser.vue?vue&type=template&id=19c6dcf5"
import script from "./GifsTableUser.vue?vue&type=script&lang=js"
export * from "./GifsTableUser.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__